module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic06.f56fe2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic06.png
// module id = 540
// module chunks = 1